import { auth, db, storage, onAuthStateChanged } from "./firebase.js";
import { formatDate } from "./utilities.js";
import {
  TextCensor,
  RegExpMatcher,
  englishDataset,
  englishRecommendedTransformers,
} from "obscenity";
import {
  collection,
  getDoc,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  serverTimestamp,
  doc,
  updateDoc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";

import {
  ref,
  uploadBytes,
  getDownloadURL,
  getMetadata,
} from "firebase/storage";
import { Splide } from "@splidejs/splide";
import "../scss/store.scss";
let selectedRating = 0;
let lastVisibleDoc = null;
var user_id;
const urlParams = new URLSearchParams(window.location.search);
const reportModalBtn = document.getElementById("report_modal_btn");
const reportModal = document.getElementById("report_modal");
const report_info = document.getElementById("report_info");
const customer_img_modal = document.getElementById("customer_img_modal");
const imageInput = document.getElementById("image-input");
const imagePreview = document.getElementById("image-preview");
const uploadButton = document.getElementById("upload-button");
const stars = document.querySelectorAll(".star_select");
const thrift_review_container = document.getElementById(
  "thrift_store_reviews_container"
);
const claimButton = document.getElementById("claim_modal_btn");
const claimButtonClose = document.getElementById("claimModal-modal-close-btn");
const reviewButton = document.querySelector(".store_review_btn");
const printIcon = document.getElementById("print_icon");
const shareIcon = document.getElementById("share_icon");
const likeIcon = document.getElementById("like_icon");
var storeRatingDisplay = document.getElementById("store-rating-display");
var storeRatingDisplayWrap = document.getElementById(
  "store-rating-display-wrap"
);
const reviewsContainer = document.getElementById("reviews-container");
let selectedFile;

if (likeIcon) {
  const heartIcon = likeIcon.querySelector("i");
}

document.addEventListener("DOMContentLoaded", async function () {
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      if (likeIcon) {
        loadLikes(store_id);
      }
    }
  });

  if (store_listing_type != "basic") {
    populateSliderTwo(store_uid);

    const storeRatingRef = doc(db, "stores_managed", store_uid);
    const storeRatingSnap = await getDoc(storeRatingRef);
    if (storeRatingSnap.exists()) {
      const storeRatingData = storeRatingSnap.data();
      const switch_state = storeRatingData.listing_ratings;

      if (switch_state) {
        storeRatingDisplayWrap.style.display = "block";
        reviewButton.style.display = "block";
        thrift_review_container.style.display = "block";
        loadRatings(store_id);
        loadReviews(store_id);
      } else {
        storeRatingDisplayWrap.style.display = "none";
        reviewButton.style.display = "none";
        thrift_review_container.style.display = "none";
      }
    }
  } else {
    loadRatings(store_id);
    loadReviews(store_id);
  }

  loadCustomerImages(store_id);

  document.querySelectorAll(".star_select").forEach((star) => {
    star.addEventListener("click", function () {
      selectedRating = parseInt(this.getAttribute("data-value"), 10);
      updateStarRating(selectedRating); // Update the visual representation of selected stars
    });
  });

  if (storeRatingDisplay) {
    storeRatingDisplay.addEventListener("click", function () {
      reviewButton.scrollIntoView({ behavior: "smooth" });
    });
  }
  // Add event listener to the click LIKE Icon
  if (likeIcon) {
    likeIcon.addEventListener("click", function () {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          const heartIcon = likeIcon.querySelector("i");
          // User is signed in
          heartIcon.classList.toggle("liked");
          const userId = user.uid;
          const likeRef = doc(
            db,
            "accounts",
            userId,
            "likes",
            store_id // Use store_id as the document ID
          );
          const likeData = {
            liked: true, // You can add additional data if needed
          };

          if (heartIcon.classList.contains("liked")) {
            // Add the like data
            await setDoc(likeRef, {});
          } else {
            // Remove the like data
            deleteDoc(likeRef)
              .then(() => {
                // Optionally, display a confirmation message to the user
              })
              .catch((error) => {
                console.error("Error removing liked item: ", error);
                // Optionally, display an error message to the user
              });
          }
        } else {
          // No user is signed in
          showModal();
        }
      });
    });
  }

  if (printIcon) {
    printIcon.addEventListener("click", function () {
      // Call the print function when the icon is clicked
      window.print();
    });
  }
  if (shareIcon) {
    if (navigator.share) {
      // If the Web Share API is supported by the browser
      shareIcon.addEventListener("click", async function () {
        try {
          await navigator.share({
            title: "Title of the shared content",
            text: "Description of the shared content",
            url: "URL of the shared content",
          });
        } catch (error) {
          console.error("Error sharing:", error);
        }
      });
    } else {
      // If the Web Share API is not supported
      shareIcon.addEventListener("click", function () {
        // Fallback mechanism (e.g., display a message or use another sharing method)
        console.log("Web Share API is not supported");
      });
    }
  }
  if (reportModalBtn && reportModal) {
    reportModalBtn.addEventListener("click", function () {
      const bootstrapModal = new bootstrap.Modal(reportModal);
      bootstrapModal.show();
    });

    // Close modal when close button is clicked
    const closeModalBtn = document.querySelector(".btn-close");
    if (closeModalBtn) {
      closeModalBtn.addEventListener("click", function () {
        const bootstrapModal = bootstrap.Modal.getInstance(reportModal);
        bootstrapModal.hide();
      });
    }
  }

  if (claimButton) {
    claimButton.addEventListener("click", function () {
      show_claim_modal();
    });
  }

  if (reviewButton) {
    reviewButton.addEventListener("click", function () {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          // User is signed in
          //console.log("User is signed in. Proceed with writing a review.");
          // Add code to handle the review process
          reviewModal(store_id);
        } else {
          // No user is signed in
          //console.log("No user is signed in. Prompt for login or sign up.");
          // Add code to handle the login/sign-up process
          //location = "/members/login/";
          showModal();
        }
      });
    });
  }

  const customer_img_button = document.querySelector(
    ".store_customer_image_btn"
  );
  if (customer_img_button) {
    customer_img_button.addEventListener("click", function () {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          user_id = user.uid;
          console.log("User is signed in. Proceed with image upload.");

          const modal = new bootstrap.Modal(
            document.getElementById("customer_img_modal")
          );
          modal.show();

          customer_img_photo(store_id, user_id); // Load user-specific photo data
        } else {
          console.log("User is not signed in.");
          showModal(); // Show login modal
        }
      });
    });
  } else {
    console.error("Customer image button not found in the DOM.");
  }

  const login_from_store = document.querySelector("#login_from_store");
  if (login_from_store) {
    login_from_store.addEventListener("click", function () {
      location =
        "/members/login/?store_id=" + store_id + "&store_redirect=" + store_url;
    });
  }

  const register_from_store = document.querySelector("#register_from_store");
  if (register_from_store) {
    register_from_store.addEventListener("click", function () {
      location =
        "/members/register/?store_id=" +
        store_id +
        "&store_redirect=" +
        store_url;
    });
  }

  const login_claim = document.querySelector("#login_claim");
  if (login_claim) {
    login_claim.addEventListener("click", function () {
      location =
        "/members/login/?store_id=" +
        store_id +
        "&store_redirect=" +
        store_url +
        "&claim=true";
    });
  }

  const register_claim = document.querySelector("#register_claim");
  if (register_claim) {
    register_claim.addEventListener("click", function () {
      location =
        "/members/register/?store_id=" +
        store_id +
        "&store_redirect=" +
        store_url +
        "&claim=true";
    });
  }

  function reviewModal(store_id) {
    const modalElement = document.getElementById("review_modal");
    if (modalElement) {
      // Initialize the Bootstrap 5 modal
      const modal = new bootstrap.Modal(modalElement);

      onAuthStateChanged(auth, (user) => {
        if (user) {
          const userRatingRef = doc(
            db,
            "stores",
            store_id,
            "ratings",
            user.uid
          );
          getDoc(userRatingRef).then((docSnapshot) => {
            if (docSnapshot.exists()) {
              const data = docSnapshot.data();
              updateStarRating(data.rating); // Function to visually update stars
              document.getElementById("review_text").value =
                data.reviewText || "";

              // Prompt for display name only if review text is entered
              if (data.reviewText) {
                // Perform any additional operations (e.g., submitting data)
                ratingDisplay(store_id, selectedRating, reviewText, displayName)
                  .then(() => {
                    // Operation successful: Hide the modal
                    modal.hide();
                  })
                  .catch((error) => {
                    // Handle any errors
                    console.error("Error submitting rating: ", error);
                    alert(
                      "There was an error submitting your review. Please try again."
                    );
                  });
              }
            } else {
              updateStarRating(0); // Reset stars
              document.getElementById("review_text").value = ""; // Clear text area
            }
          });
        }
      });

      // Show the modal using Bootstrap's Modal API
      modal.show();
    }
  }

  // Event delegation to handle modal close button click
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (target && target.id === "modal-close-btn") {
      const modal = document.getElementById("memberModal");
      if (modal) {
        modal.style.display = "none"; // Hide the modal
      }
    }
  });

  document
    .getElementById("submit_review")
    .addEventListener("click", async function () {
      let reviewText = document.getElementById("review_text").value;
      const displayName = document.getElementById("display_name").value;
      const storeName = document.getElementById("store_name_review").value;
      const return_url = window.location.href;
      const submitButton = this; // Reference to the submit button
      const originalButtonText = submitButton.textContent; // Store original button text
      const modalElement = document.getElementById("review_modal"); // Get the modal element
      const bootstrapModal = bootstrap.Modal.getInstance(modalElement); // Get the Bootstrap modal instance

      if (selectedRating === 0) {
        alert("Please select a rating before submitting.");
        return;
      }

      const {
        TextCensor,
        RegExpMatcher,
        englishDataset,
        englishRecommendedTransformers,
      } = await import("obscenity");
      const matcher = new RegExpMatcher({
        ...englishDataset.build(),
        ...englishRecommendedTransformers,
      });
      const censor = new TextCensor();
      const matches = matcher.getAllMatches(reviewText);
      reviewText = censor.applyTo(reviewText, matches);

      // Check if display name is provided
      if (!displayName) {
        // Show error message inside the modal
        document.getElementById("display_name_error").innerText =
          "Display name is required.";
        return; // Exit if display name is not provided
      }

      // Show loading feedback and disable the button to prevent multiple submissions
      submitButton.textContent = "Submitting...";
      submitButton.disabled = true;

      // Check if user is signed in
      onAuthStateChanged(auth, (user) => {
        if (user) {
          addRating(
            store_id,
            selectedRating,
            reviewText,
            displayName,
            storeName,
            return_url
          )
            .then(() => {
              // Operation successful: Close the modal using Bootstrap's Modal API
              if (bootstrapModal) bootstrapModal.hide();
            })
            .catch((error) => {
              // Handle any errors
              console.error("Error submitting rating: ", error.message); // Log error message
              console.error("Error code: ", error.code); // Log error code
              console.error("Stack trace: ", error.stack); // Log stack trace
              console.error("Error submitting rating: ", error);
              alert(
                "There was an error submitting your review. Please try again."
              );
            })
            .finally(() => {
              // Restore button state regardless of operation outcome
              submitButton.textContent = originalButtonText;
              submitButton.disabled = false;
            });
        } else {
          console.log("User is not signed in.");
          // Optionally, handle the case where the user isn't signed in
          // Close the modal without submitting
          if (bootstrapModal) bootstrapModal.hide();
          submitButton.textContent = originalButtonText;
          submitButton.disabled = false;
        }
      });
    });

  // Event delegation to close the modal if the user clicks outside of it
  window.addEventListener("click", function (event) {
    const modal = document.getElementById("memberModal");
    if (modal && event.target === modal) {
      modal.style.display = "none"; // Hide the modal
    }
  });

  // Event delegation to handle modal close button click
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (target && target.id === "modal-close-btn") {
      const modal = document.getElementById("review_modal");
      if (modal) {
        modal.style.display = "none"; // Hide the modal
      }
    }
  });

  // Event delegation to close the modal if the user clicks outside of it
  window.addEventListener("click", function (event) {
    const modal = document.getElementById("review_modal");
    if (modal && event.target === modal) {
      modal.style.display = "none"; // Hide the modal
    }
  });

  // Event delegation to close the modal if the user clicks outside of it
  window.addEventListener("click", function (event) {
    const modal = document.getElementById("customer_img_modal");
    if (modal && event.target === modal) {
      modal.style.display = "none"; // Hide the modal
    }
  });

  // Event delegation to handle modal close button click
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (target && target.id === "modal-close-btn") {
      const modal = document.getElementById("customer_img_modal");
      if (modal) {
        modal.style.display = "none"; // Hide the modal
      }
    }
  });

  stars.forEach((star) => {
    star.addEventListener("click", function () {
      let rating = parseInt(this.dataset.value, 10);
      updateStarRating(rating);
    });
  });

  imageInput.addEventListener("change", function (event) {
    selectedFile = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      imagePreview.src = e.target.result;
      imagePreview.style.display = "block";
    };

    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    } else {
      imagePreview.src = "";
      imagePreview.style.display = "none";
    }
  });

  uploadButton.addEventListener("click", async function () {
    if (!selectedFile) {
      alert("Please select an image first.");
      return;
    }
    const store_name = document.getElementById("store_name_customer_img").value;
    let caption_text = document.getElementById("caption_text").value;
    const display_name = document.getElementById("display_name_img").value;
    const return_url = window.location.href;
    const filePath = `stores/${user_id}/${store_id}/${user_id}-1`;
    const storageRef = ref(storage, filePath);

    const {
      TextCensor,
      RegExpMatcher,
      englishDataset,
      englishRecommendedTransformers,
    } = await import("obscenity");
    const matcher = new RegExpMatcher({
      ...englishDataset.build(),
      ...englishRecommendedTransformers,
    });
    const censor = new TextCensor();
    const matches = matcher.getAllMatches(caption_text);
    caption_text = censor.applyTo(caption_text, matches);

    try {
      // Upload image to Firebase Storage
      await uploadBytes(storageRef, selectedFile);
      // Get the download URL for the uploaded image
      const imageUrl = await getDownloadURL(storageRef);

      // Update Firestore with the image URL
      const userStoreImagesRef = doc(
        db,
        "stores",
        store_id,
        "customer_images",
        user_id
      );
      const accountStoreImagesRef = doc(
        db,
        "accounts",
        user_id,
        "customer_images",
        store_id
      );

      const userUpdateData = {
        user_id: user_id,
        store_name: store_name,
        image_url_one: imageUrl,
        caption_text: caption_text,
        display_name: display_name,
        timestamp: serverTimestamp(),
        return_url: return_url,
      };

      const storeUpdateData = {
        user_id: user_id,
        store_name: store_name,
        image_url_one: imageUrl,
        caption_text: caption_text,
        display_name: display_name,
        timestamp: serverTimestamp(),
        return_url: return_url,
      };

      await setDoc(accountStoreImagesRef, userUpdateData, { merge: true });
      await setDoc(userStoreImagesRef, storeUpdateData, { merge: true });

      customer_img_modal.style.display = "none";
      // Close the modal
      location.reload();
    } catch (error) {
      // Handle errors
      //console.error("Error uploading image:", error);
      alert("An error occurred while uploading the image. Please try again.");

      // Log additional information about the error
      console.error("Error details:", error.message);
      console.error("Error code:", error.code);
      console.error("Error stack trace:", error.stack);
    }
  });


  function showModal() {
    const modalElement = document.getElementById("memberModal");
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
function show_claim_modal() {
  const modalElement = document.getElementById("claimModal");
  if (modalElement) {
    const bootstrapModal = new bootstrap.Modal(modalElement);
    bootstrapModal.show();
  } else {
    console.error("Claim modal element not found.");
  }
}

if (claimButtonClose) {
  claimButtonClose.addEventListener("click", () => {
    const modal = document.getElementById("claimModal");
    if (modal) {
      modal.style.display = "none";
    }
  });
}
async function customer_img_photo(store_id, user_id) {
  // Check if the user has already uploaded an image
  const filePath = `stores/${user_id}/${store_id}/${user_id}-1`;
  const storageRef = ref(storage, filePath);

  try {
    // Check if the file metadata exists
    await getMetadata(storageRef);

    // If the file exists, proceed to retrieve its download URL
    const imageUrl = await getDownloadURL(storageRef);
    // If image exists, display it in the imagePreview element
    imagePreview.src = imageUrl;
    imagePreview.style.display = "block";
  } catch (error) {
    // If no image exists or there's an error, hide the imagePreview element
    imagePreview.style.display = "none";
  }
}

function updateStarRating(rating) {
  const stars = document.querySelectorAll(".star_select");

  stars.forEach((star, index) => {
    if (index < rating) {
      star.classList.add("text-warning");
    } else {
      star.classList.remove("text-warning");
    }
  });
}

function ratingDisplay(store_id, rating, reviewText, displayName) {
  // Returns a Promise that resolves or rejects based on the Firestore operation
  return new Promise((resolve, reject) => {
    // Assume user is already authenticated and user.uid is available
    const userRatingRef = doc(
      db,
      "stores",
      store_id,
      "ratings",
      auth.currentUser.uid
    );
    const accountRatingRef = doc(
      db,
      "accounts",
      auth.currentUser.uid,
      "ratings",
      store_id
    );

    getDoc(userRatingRef)
      .then((docSnapshot) => {
        const ratingData = {
          rating: rating,
          reviewText: reviewText || "",
          display_name: displayName || "",
          timestamp: serverTimestamp(),
        };

        if (docSnapshot.exists()) {
          // Update existing rating
          updateDoc(userRatingRef, ratingData)
            .then(() => {
              // Update or add the rating data to the accounts section
              setDoc(accountRatingRef, ratingData, { merge: true }) // Merge to avoid overwriting other fields
                .then(resolve)
                .catch(reject);
            })
            .catch(reject);
        } else {
          // Add new rating
          setDoc(userRatingRef, ratingData)
            .then(() => {
              // Update or add the rating data to the accounts section
              setDoc(accountRatingRef, ratingData, { merge: true }) // Merge to avoid overwriting other fields
                .then(resolve)
                .catch(reject);
            })
            .catch(reject);
        }
      })
      .catch((error) => {
        // Handle errors during Firestore operation
        console.error("Error fetching document:", error);
        reject(error); // Reject the Promise with the encountered error
      });
  });
}
function addRating(
  store_id,
  rating,
  reviewText,
  displayName,
  storeName,
  return_url
) {
  // Returns a Promise that resolves or rejects based on the Firestore operation
  return new Promise((resolve, reject) => {
    // Assume user is already authenticated and user.uid is available
    const userRatingRef = doc(
      db,
      "stores",
      store_id,
      "ratings",
      auth.currentUser.uid
    );
    const accountRatingRef = doc(
      db,
      "accounts",
      auth.currentUser.uid,
      "ratings",
      store_id
    );

    getDoc(userRatingRef)
      .then((docSnapshot) => {
        const ratingData = {
          rating: rating,
          reviewText: reviewText || "",
          display_name: displayName || "",
          timestamp: serverTimestamp(),
          store_name: storeName,
          return_url: return_url,
        };

        if (docSnapshot.exists()) {
          // Update existing rating
          updateDoc(userRatingRef, ratingData)
            .then(() => {
              // Update or add the rating data to the accounts section
              updateDoc(accountRatingRef, ratingData, { merge: true }) // Merge to avoid overwriting other fields
                .then(() => {
                  // Call the updateRatingStars function after successfully adding the rating
                  updateRatingStars(store_id);
                  resolve(); // Resolve the Promise
                })
                .catch(reject);
            })
            .catch(reject);
        } else {
          // Add new rating
          setDoc(userRatingRef, ratingData)
            .then(() => {
              // Update or add the rating data to the accounts section
              setDoc(accountRatingRef, ratingData, { merge: true }) // Merge to avoid overwriting other fields
                .then(() => {
                  // Call the updateRatingStars function after successfully adding the rating
                  updateRatingStars(store_id);
                  resolve(); // Resolve the Promise
                })
                .catch(reject);
            })
            .catch(reject);
        }
      })
      .catch((error) => {
        // Handle errors during Firestore operation
        console.error("Error fetching document:", error);
        reject(error); // Reject the Promise with the encountered error
      });
  });
}

async function loadCustomerImages(store_id) {
  try {
    const querySnapshot = await getDocs(
      collection(db, "stores", store_id, "customer_images")
    );
    const sectionContainer = document.getElementById("customer-image-section");

    if (!querySnapshot.empty) {
      const imgData = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        imgData.push({
          imageUrl: data.image_url_one,
          captionText: data.caption_text,
          displayName: data.display_name,
          storeName: data.store_name,
          submitted: data.timestamp,
        });
      });

      sectionContainer.style.display = "block";

      const splideList = document.querySelector(
        "#image-carousel .splide__list"
      );

      imgData.forEach((imgInfo, index) => {
        const slide = document.createElement("li");
        slide.classList.add("splide__slide");

        const imgElement = document.createElement("img");
        imgElement.src = imgInfo.imageUrl;
        slide.appendChild(imgElement);

        // Add description
        // const description = document.createElement("div");
        // description.textContent = "Description " + (index + 1);
        // slide.appendChild(description);

        splideList.appendChild(slide);

        // Add click event listener to each image
        imgElement.addEventListener("click", () => {
          view_customer_img(
            imgInfo.imageUrl,
            imgInfo.captionText,
            imgInfo.displayName,
            imgInfo.storeName,
            imgInfo.submitted
          );
        });
      });

      // Add static image as the last slide
      const staticSlide = document.createElement("li");
      staticSlide.classList.add("splide__slide");
      staticSlide.classList.add("static-image-class");

      const staticImg = document.createElement("img");
      staticImg.src = "/images/customer_add_img.png";
      staticImg.classList.add("static-image-class");
      staticImg.alt = "Static Image";
      staticSlide.appendChild(staticImg);

      splideList.appendChild(staticSlide);

      // Add a click event listener to the static image
      staticImg.addEventListener("click", function (event) {
        onAuthStateChanged(auth, (user) => {
          if (user) {
            user_id = user.uid;
            console.log("User is signed in. Proceed with image upload.");
  
            const modal = new bootstrap.Modal(
              document.getElementById("customer_img_modal")
            );
            modal.show();
  
            customer_img_photo(store_id, user_id); // Load user-specific photo data
          } else {
            console.log("User is not signed in.");
            showModal(); // Show login modal
          }
        });
      });

      // Initialize Splide carousel after adding slides.
      new Splide("#image-carousel", {
        fixedWidth: 350,
        fixedHeight: 275,
        gap: 15,
        rewind: true, // Enable loop
        breakpoints: {
          640: {
            perPage: 1,
          },
        },
      }).mount();
    } else {
      sectionContainer.style.display = "none";
    }
  } catch (error) {
    console.error("Error loading images:", error);
  }
}

function updateRatingStars() {
  location.reload();
}

// Function to open modal
function view_customer_img(imageUrl, captionText, displayName, storeName, submitted) {
  // Populate modal fields
  const modalImage = document.getElementById("modal-image");
  const storeTitle = document.getElementById("store-title");
  const caption = document.getElementById("caption-text");
  const displayNameElement = document.getElementById("display-name");
  const submitTimestamp = document.getElementById("submit-timestamp");

  const userSubmitDate = formatDate(submitted.toMillis()); // Adjust based on your formatDate implementation

  modalImage.src = imageUrl;
  storeTitle.textContent = storeName;
  caption.textContent = captionText;
  displayNameElement.textContent = displayName ? `Submitted by ${displayName}` : "";
  submitTimestamp.textContent = userSubmitDate;

  // Show modal
  const modal = new bootstrap.Modal(document.getElementById("customer_img_modal_display"));
  modal.show();
}

function openImageModal(imageUrl) {
  // Add code to open modal and display the selected image
  console.log("Open modal with image:", imageUrl);
}

function loadLikes(store_id) {
  const heartIcon = likeIcon.querySelector("i");
  if (typeof store_id !== "string" || !store_id) {
    console.error("store_id is undefined or not a string");
    return;
  }

  onAuthStateChanged(auth, (user) => {
    if (user) {
      const userId = user.uid;
      const likeRef = doc(
        db,
        "accounts",
        userId,
        "likes",
        store_id // Use store_id as the document ID
      );

      getDoc(likeRef)
        .then((docSnapshot) => {
          if (docSnapshot.exists()) {
            // Liked item exists
            heartIcon.classList.add("liked");
          } else {
            // Liked item does not exist
            heartIcon.classList.remove("liked");
          }
        })
        .catch((error) => {
          console.error("Error getting liked item: ", error);
        });
    }
  });
}

function loadRatings(store_id) {
  if (typeof store_id !== "string" || !store_id) {
    console.error("store_id is undefined or not a string");
    return;
  }

  const ratingsRef = collection(db, "stores", store_id, "ratings");
  getDocs(ratingsRef)
    .then((querySnapshot) => {
      let totalRating = 0;
      let ratingCount = 0;

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const ratingNumber = parseFloat(data.rating); // Convert rating to a number
        totalRating += ratingNumber;
        ratingCount++;
      });

      $("#star_average").text(`(${ratingCount})`);

      if (ratingCount > 0) {
        const averageRating = totalRating / ratingCount;
        //console.log("Average Rating:", averageRating); // Debugging
        updateStarRatingUI(averageRating);
      }
    })
    .catch((error) => {
      console.error("Error loading ratings: ", error);
    });
}

function updateStarRatingUI(averageRating) {
  const roundedRating = Math.round(averageRating); // Round rating to nearest whole number
  const stars = document.querySelectorAll(`#store-rating-display .star`);
  //console.log("Stars Found:", stars.length, stars); // Debugging

  stars.forEach((star, index) => {
    if (index < roundedRating) {
      star.classList.remove("text-muted");
      star.classList.add("text-warning");
    } else {
      star.classList.remove("text-warning");
      star.classList.add("text-muted");
    }
    //console.log(`Star ${index + 1}:`, star.classList); // Debugging
  });
}

function loadReviews(store_id) {
  const pageSize = 5;

  let reviewsQuery = query(
    collection(db, "stores", store_id, "ratings"),
    orderBy("timestamp", "desc"),
    limit(pageSize)
  );

  if (lastVisibleDoc) {
    reviewsQuery = query(
      collection(db, "stores", store_id, "ratings"),
      orderBy("timestamp", "desc"),
      startAfter(lastVisibleDoc),
      limit(pageSize)
    );
  }

  // Create the header div with a class, h5, and p
  const headerDiv = document.createElement("div");
  headerDiv.classList.add("reviews-header");
  headerDiv.innerHTML = `
    <h5>Reviews and Ratings</h5>
    <p>Check out what others are saying about the ${store_name}.</p>
  `;

  // Create a wrapper div for comments
  const commentsWrapperDiv = document.createElement("div");
  commentsWrapperDiv.classList.add("comments-wrapper");

  reviewsContainer.innerHTML = ""; // Clear existing content
  reviewsContainer.appendChild(headerDiv);
  reviewsContainer.appendChild(commentsWrapperDiv); // Append the wrapper div to the container
  getDocs(reviewsQuery)
    .then((querySnapshot) => {
      if (!querySnapshot.empty) {
        $("#reviews-container").show();
        querySnapshot.forEach((doc) => {
          const data = doc.data(); // Define and initialize the data variable here

          const reviewElement = document.createElement("div");

          // Convert rating to filled stars
          let ratingStars = "";
          for (let i = 1; i <= 5; i++) {
            if (i <= data.rating) {
              ratingStars +=
                '<span class="star text-warning" data-value="' +
                i +
                '">&#9733;</span>';
            } else {
              ratingStars +=
                '<span class="star text-muted" data-value="' +
                i +
                '">&#9733;</span>';
            }
          }
          const review_data = formatDate(data.timestamp.toMillis());
          reviewElement.innerHTML = `
          <div class="star-rating-comment">${ratingStars}</div>
          <div>${data.reviewText}</div>
          <div>${data.display_name} on ${review_data}</div>
          <hr />
        `;
          commentsWrapperDiv.appendChild(reviewElement); // Append the comment to the wrapper div
        });
        // Update lastVisibleDoc for pagination
        lastVisibleDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
      } else {
        $("#reviews-container").show();
        commentsWrapperDiv.innerHTML =
          '<div class="padding:20px;">No reviews submitted yet for this store.</div>'; // Show message inside the wrapper div
      }
    })
    .catch((error) => {
      $("#reviews-container").hide();
      console.error("Error loading reviews: ", error);
      //commentsWrapperDiv.innerHTML = '<div>Error loading reviews.</div>'; // Show error message inside the wrapper div
    });

  // Optional: Setup a "Load More" button
  const loadMoreButton = document.getElementById("load-more-reviews");
  if (loadMoreButton) {
    loadMoreButton.onclick = () => loadReviews(store_id);
  }
}

function handlePagination(store_id, lastVisibleDoc) {
  const nextPageButton = document.getElementById("next-page-button"); // Make sure this button exists in your HTML
  if (!lastVisibleDoc) {
    nextPageButton.style.display = "none"; // Hide if there's no more data to paginate
    return;
  }
  nextPageButton.style.display = "block";
  nextPageButton.onclick = () => loadReviews(store_id, lastVisibleDoc);
}

if (report_info) {
  report_info.addEventListener("submit", handleSubmit);
}

// Function to check if an email address is valid
function checkValidEmailAddress(emailAddress) {
  var pattern = new RegExp(
    /^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i
  );
  return pattern.test(emailAddress);
}
function handleSubmit(event) {
  event.preventDefault();
  // Get form inputs
  var uname = document.getElementById("name").value;
  var uinfo = document.querySelector('input[name="inforadio"]:checked');
  var uemail = document.getElementById("email").value;
  var umsg = document.getElementById("message").value;
  var ucaptcha = document.getElementById("captchavalue").value;

  // Check for valid inputs
  var mailsendstatus = true; // Assume inputs are valid unless proven otherwise

  // Check name
  if (!uname || uname.length <= 3) {
    document.getElementById("namelabel").querySelector(".err").style.display =
      "block";
    mailsendstatus = false;
  } else {
    document.getElementById("namelabel").querySelector(".err").style.display =
      "none";
  }

  // Check selected radio button
  if (!uinfo) {
    document.getElementById("infolabel").querySelector(".err").style.display =
      "block";
    mailsendstatus = false;
  } else {
    document.getElementById("infolabel").querySelector(".err").style.display =
      "none";
  }

  // Check email
  if (!checkValidEmailAddress(uemail)) {
    document.getElementById("emailabel").querySelector(".err").style.display =
      "block";
    mailsendstatus = false;
  } else {
    document.getElementById("emailabel").querySelector(".err").style.display =
      "none";
  }

  // Check message
  if (!umsg || umsg.length <= 5) {
    document.getElementById("msglabel").querySelector(".err").style.display =
      "block";
    mailsendstatus = false;
  } else {
    document.getElementById("msglabel").querySelector(".err").style.display =
      "none";
  }

  $.ajax(
    {
      type: "POST",
      url: "/update/captcha_check.php",
      data: $("#report_info").serialize(),
      success: function (data) {
        if (data == "false") {
          mailsendstatus = false;
          $("#captchalabel").children(".err").fadeIn("slow");
        } else if (data == "true") {
          $("#captchalabel").children(".err").fadeOut("slow");

          if (
            uname.length > 3 &&
            umsg.length > 5 &&
            checkValidEmailAddress(uemail)
          ) {
            // in this case all of our inputs look good
            // so we say true and send the mail
            mailsendstatus = true;

            $("#subber").html('<img src="load.gif" alt="loading...">');

            $.ajax({
              type: "POST",
              url: "/update/update-mailer.php",
              data: $("#contact").serialize(),
              success: function (data) {
                if (data == "yes") {
                }
              },
            }); // close sending email ajax call
          } // close if logic for mailsendstatus true
        } // close check CAPTCHA return true
      }, // close ajax success callback function
    } // close ajax bracket open
  );

  if (mailsendstatus) {
    // If all inputs are valid, submit the form
    document.getElementById("subber").innerHTML =
      '<img src="load.gif" alt="loading...">';

    // You may need to adjust the URL and data being sent based on your backend setup
    var formData = new FormData(document.getElementById("report_info"));

    fetch("index.php", {
      method: "POST",
      body: formData,
    })
      .then(function (response) {
        if (response.ok) {
          // Handle successful form submission
          document.getElementById("contact").style.display = "none"; // Hide the form
          document
            .getElementById("subber")
            .insertAdjacentHTML(
              "beforebegin",
              '<div style="font-weight:bold;font-size:16px;color:#1d4058;">Thank you for contacting us! We\'ll get back to you shortly.</div><div style="margin-top:15px;"></div>'
            );
        } else {
          // Handle form submission error
          console.error("Form submission failed.");
        }
      })
      .catch(function (error) {
        console.error("Error:", error);
      });
  }
}

async function populateSliderTwo(uid) {
  var main = new Splide("#main-slider", {
    type: "fade",
    rewind: true,
    pagination: false,
    arrows: false,
  });

  // Initialize thumbnail slider
  var thumbnails = new Splide("#thumbnail-slider", {
    fixedWidth: 100,
    fixedHeight: 60,
    gap: 10,
    rewind: true,
    pagination: false,
    cover: true,
    isNavigation: true,
    breakpoints: {
      600: {
        fixedWidth: 60,
        fixedHeight: 44,
      },
    },
  });

  // Fetch image URLs from Firestore
  const imageUrls = await getAllImageUrlsFromFirestore(uid);

  // If no image URLs are found, use the default image
  if (imageUrls.length === 0) {
    const defaultImageUrl = "/images/default_store.png"; // Replace with the path to your default image
    imageUrls.push(defaultImageUrl);
  }

  // Populate main slider with image URLs
  imageUrls.forEach(function (url) {
    var mainSlide = document.createElement("li");
    mainSlide.classList.add("splide__slide");
    mainSlide.innerHTML = '<img src="' + url + '" alt="Main Image">';
    main.root.querySelector(".splide__list").appendChild(mainSlide);
  });

  // Populate thumbnail slider with image URLs
  imageUrls.forEach(function (url) {
    var thumbnailSlide = document.createElement("li");
    thumbnailSlide.classList.add("splide__slide");
    thumbnailSlide.innerHTML = '<img src="' + url + '" alt="Thumbnail">';
    thumbnails.root.querySelector(".splide__list").appendChild(thumbnailSlide);
  });

  // Sync main slider with thumbnail slider
  main.sync(thumbnails);

  // Mount both sliders
  main.mount();
  thumbnails.mount();

  async function getAllImageUrlsFromFirestore(uid) {
    try {
      // Fetch the document from Firestore
      const docRef = doc(db, "stores_managed", uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const imageUrls = [];

        // Check if each image URL field exists in the document
        if (data.store_image_url_main) {
          imageUrls.push(data.store_image_url_main);
        }
        if (data.store_image_url_1) {
          imageUrls.push(data.store_image_url_1);
        }
        if (data.store_image_url_2) {
          imageUrls.push(data.store_image_url_2);
        }
        if (data.store_image_url_3) {
          imageUrls.push(data.store_image_url_3);
        }
        if (data.store_image_url_4) {
          imageUrls.push(data.store_image_url_4);
        }

        // Log the retrieved image URLs for debugging
        // console.log(imageUrls);

        // Return the array of image URLs
        return imageUrls;
      } else {
        // Return an empty array if the document doesn't exist
        return [];
      }
    } catch (error) {
      console.error("Error getting image URLs from Firestore:", error);
      return []; // Return an empty array if an error occurs
    }
  }
}
});
